import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  LineHeight,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
  marginBottom: Spacing.LG,
});

export const subheadingClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.MEDIUM,
});

export const linkClassName = css({
  color: Colors.Brand,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const listClassName = css({
  display: 'flex',
  flexDirection: 'column',
  marginTop: Spacing.XL,
  marginBottom: Spacing.MD,
});

export const itemClassName = css({
  alignItems: 'center',
  display: 'flex',
  marginTop: 36,
  '&:first-child': {
    marginTop: 0,
  },
});

export const mediaClassName = css({
  background: Colors.BrandLight,
  borderRadius: 4,
  padding: Spacing.MD,
});

export const iconClassName = css({
  color: Colors.Brand,
  '& svg': {
    height: 18,
    width: 18,
  },
});

export const textClassName = css({
  marginLeft: Spacing.LG,
});

export const titleClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
});

export const subtitleClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.NORMAL,
  lineHeight: LineHeight.LARGE,
  marginTop: Spacing['2XS'],
});
